import style from './style';

const Footer = props => (
    <footer class={`${style.footer} ${style[`footer--${props.site}`]} ${props.overlayVisible ? style[`footer-hidden--${props.site}`] : ''}`}>
        <span>(c) Настоящее Время | Design by Pangea Digital</span>
    </footer>
);

export default Footer;
